import { Row, Col, Form } from "react-bootstrap";

import classes from "./profile.module.scss";

const ProfileTabSecurity = ({ data, setData }) => {
	return (
		<Row className={classes.content_main_row}>
			<Col md={12} xs={12}>
				<Form.Group as={Row} className="mb-3">
					<Form.Label column sm={2} xs={2} className={classes.label}>
						Contraseña
					</Form.Label>
					<Col sm={10} xs={10}>
						<Form.Control
							value={data && data.password}
							onChange={(e) =>
								setData({
									...data,
									password: e.currentTarget.value,
								})
							}
							type="password"
						/>
					</Col>
				</Form.Group>

				<Form.Group as={Row} className="mb-3">
					<Form.Label column sm="2" xs={2} className={classes.label}>
						Confirmar Contraseña
					</Form.Label>
					<Col sm="10" xs={10}>
						<Form.Control
							value={data && data.confirm_password}
							onChange={(e) =>
								setData({
									...data,
									confirm_password: e.currentTarget.value,
								})
							}
							type="password"
						/>
					</Col>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default ProfileTabSecurity;
